import { authService } from '../services/auth';

export class TokenManager {
  private static checkInterval: NodeJS.Timeout | null = null;
  private static readonly CHECK_INTERVAL_MS = 60000; // Check every minute

  static startTokenMonitoring() {
    // Clear any existing interval
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }

    // Check token validity immediately
    this.checkTokenValidity();

    // Set up periodic checks
    this.checkInterval = setInterval(() => {
      this.checkTokenValidity();
    }, this.CHECK_INTERVAL_MS);
  }

  static stopTokenMonitoring() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
    }
  }

  private static async checkTokenValidity() {
    try {
      const currentUser = await authService.getCurrentUser();
      
      // Check if token is expired
      if (currentUser.token_expires_at) {
        const expiresAt = new Date(currentUser.token_expires_at);
        const now = new Date();
        
        // If token expires in less than 5 minutes, refresh it
        if (expiresAt.getTime() - now.getTime() < 5 * 60 * 1000) {
          console.log('Token expiring soon, refreshing...');
          await authService.refreshToken();
        }
      }
    } catch (error) {
      console.log('Token validation failed, logging out...');
      await authService.signOut();
      window.location.href = '/';
    }
  }

  static isTokenExpired(): boolean {
    const expiresAt = localStorage.getItem('token_expires_at');
    if (!expiresAt) return true;
    
    const expirationDate = new Date(expiresAt);
    return expirationDate <= new Date();
  }
}
